/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiConferenceGet$Any } from '../fn/conference/api-conference-get-any';
import { ApiConferenceGet$Any$Params } from '../fn/conference/api-conference-get-any';
import { apiConferenceGet$Json } from '../fn/conference/api-conference-get-json';
import { ApiConferenceGet$Json$Params } from '../fn/conference/api-conference-get-json';
import { apiConferenceGet$JsonOdataMetadataFull } from '../fn/conference/api-conference-get-json-odata-metadata-full';
import { ApiConferenceGet$JsonOdataMetadataFull$Params } from '../fn/conference/api-conference-get-json-odata-metadata-full';
import { apiConferenceGet$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/conference/api-conference-get-json-odata-metadata-full-odata-streaming-false';
import { ApiConferenceGet$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/conference/api-conference-get-json-odata-metadata-full-odata-streaming-false';
import { apiConferenceGet$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/conference/api-conference-get-json-odata-metadata-full-odata-streaming-true';
import { ApiConferenceGet$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/conference/api-conference-get-json-odata-metadata-full-odata-streaming-true';
import { apiConferenceGet$JsonOdataMetadataMinimal } from '../fn/conference/api-conference-get-json-odata-metadata-minimal';
import { ApiConferenceGet$JsonOdataMetadataMinimal$Params } from '../fn/conference/api-conference-get-json-odata-metadata-minimal';
import { apiConferenceGet$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/conference/api-conference-get-json-odata-metadata-minimal-odata-streaming-false';
import { ApiConferenceGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/conference/api-conference-get-json-odata-metadata-minimal-odata-streaming-false';
import { apiConferenceGet$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/conference/api-conference-get-json-odata-metadata-minimal-odata-streaming-true';
import { ApiConferenceGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/conference/api-conference-get-json-odata-metadata-minimal-odata-streaming-true';
import { apiConferenceGet$JsonOdataMetadataNone } from '../fn/conference/api-conference-get-json-odata-metadata-none';
import { ApiConferenceGet$JsonOdataMetadataNone$Params } from '../fn/conference/api-conference-get-json-odata-metadata-none';
import { apiConferenceGet$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/conference/api-conference-get-json-odata-metadata-none-odata-streaming-false';
import { ApiConferenceGet$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/conference/api-conference-get-json-odata-metadata-none-odata-streaming-false';
import { apiConferenceGet$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/conference/api-conference-get-json-odata-metadata-none-odata-streaming-true';
import { ApiConferenceGet$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/conference/api-conference-get-json-odata-metadata-none-odata-streaming-true';
import { apiConferenceGet$JsonOdataStreamingFalse } from '../fn/conference/api-conference-get-json-odata-streaming-false';
import { ApiConferenceGet$JsonOdataStreamingFalse$Params } from '../fn/conference/api-conference-get-json-odata-streaming-false';
import { apiConferenceGet$JsonOdataStreamingTrue } from '../fn/conference/api-conference-get-json-odata-streaming-true';
import { ApiConferenceGet$JsonOdataStreamingTrue$Params } from '../fn/conference/api-conference-get-json-odata-streaming-true';
import { apiConferenceGet$Plain } from '../fn/conference/api-conference-get-plain';
import { ApiConferenceGet$Plain$Params } from '../fn/conference/api-conference-get-plain';
import { apiConferenceGet$Xml } from '../fn/conference/api-conference-get-xml';
import { ApiConferenceGet$Xml$Params } from '../fn/conference/api-conference-get-xml';
import { ConferenceModelListResult } from '../models/conference-model-list-result';

@Injectable({ providedIn: 'root' })
export class ConferenceService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiConferenceGet()` */
  static readonly ApiConferenceGetPath = '/api/conference';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiConferenceGet$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiConferenceGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiConferenceGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ConferenceModelListResult>> {
    return apiConferenceGet$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiConferenceGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiConferenceGet$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiConferenceGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<ConferenceModelListResult> {
    return this.apiConferenceGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ConferenceModelListResult>): ConferenceModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiConferenceGet$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiConferenceGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiConferenceGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ConferenceModelListResult>> {
    return apiConferenceGet$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiConferenceGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiConferenceGet$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiConferenceGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<ConferenceModelListResult> {
    return this.apiConferenceGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ConferenceModelListResult>): ConferenceModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiConferenceGet$JsonOdataMetadataMinimal()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiConferenceGet$JsonOdataMetadataMinimal$Response(params?: ApiConferenceGet$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<ConferenceModelListResult>> {
    return apiConferenceGet$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiConferenceGet$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiConferenceGet$JsonOdataMetadataMinimal(params?: ApiConferenceGet$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<ConferenceModelListResult> {
    return this.apiConferenceGet$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<ConferenceModelListResult>): ConferenceModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiConferenceGet$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiConferenceGet$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiConferenceGet$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ConferenceModelListResult>> {
    return apiConferenceGet$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiConferenceGet$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiConferenceGet$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiConferenceGet$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<ConferenceModelListResult> {
    return this.apiConferenceGet$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ConferenceModelListResult>): ConferenceModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiConferenceGet$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiConferenceGet$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiConferenceGet$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ConferenceModelListResult>> {
    return apiConferenceGet$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiConferenceGet$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiConferenceGet$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiConferenceGet$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<ConferenceModelListResult> {
    return this.apiConferenceGet$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ConferenceModelListResult>): ConferenceModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiConferenceGet$JsonOdataMetadataFull()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiConferenceGet$JsonOdataMetadataFull$Response(params?: ApiConferenceGet$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<ConferenceModelListResult>> {
    return apiConferenceGet$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiConferenceGet$JsonOdataMetadataFull$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiConferenceGet$JsonOdataMetadataFull(params?: ApiConferenceGet$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<ConferenceModelListResult> {
    return this.apiConferenceGet$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<ConferenceModelListResult>): ConferenceModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiConferenceGet$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiConferenceGet$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiConferenceGet$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ConferenceModelListResult>> {
    return apiConferenceGet$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiConferenceGet$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiConferenceGet$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiConferenceGet$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<ConferenceModelListResult> {
    return this.apiConferenceGet$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ConferenceModelListResult>): ConferenceModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiConferenceGet$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiConferenceGet$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiConferenceGet$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ConferenceModelListResult>> {
    return apiConferenceGet$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiConferenceGet$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiConferenceGet$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiConferenceGet$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<ConferenceModelListResult> {
    return this.apiConferenceGet$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ConferenceModelListResult>): ConferenceModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiConferenceGet$JsonOdataMetadataNone()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiConferenceGet$JsonOdataMetadataNone$Response(params?: ApiConferenceGet$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<ConferenceModelListResult>> {
    return apiConferenceGet$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiConferenceGet$JsonOdataMetadataNone$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiConferenceGet$JsonOdataMetadataNone(params?: ApiConferenceGet$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<ConferenceModelListResult> {
    return this.apiConferenceGet$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<ConferenceModelListResult>): ConferenceModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiConferenceGet$JsonOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiConferenceGet$JsonOdataStreamingTrue$Response(params?: ApiConferenceGet$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ConferenceModelListResult>> {
    return apiConferenceGet$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiConferenceGet$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiConferenceGet$JsonOdataStreamingTrue(params?: ApiConferenceGet$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<ConferenceModelListResult> {
    return this.apiConferenceGet$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ConferenceModelListResult>): ConferenceModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiConferenceGet$JsonOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiConferenceGet$JsonOdataStreamingFalse$Response(params?: ApiConferenceGet$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ConferenceModelListResult>> {
    return apiConferenceGet$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiConferenceGet$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiConferenceGet$JsonOdataStreamingFalse(params?: ApiConferenceGet$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<ConferenceModelListResult> {
    return this.apiConferenceGet$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ConferenceModelListResult>): ConferenceModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiConferenceGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiConferenceGet$Json$Response(params?: ApiConferenceGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ConferenceModelListResult>> {
    return apiConferenceGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiConferenceGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiConferenceGet$Json(params?: ApiConferenceGet$Json$Params, context?: HttpContext): Observable<ConferenceModelListResult> {
    return this.apiConferenceGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ConferenceModelListResult>): ConferenceModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiConferenceGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiConferenceGet$Xml$Response(params?: ApiConferenceGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ConferenceModelListResult>> {
    return apiConferenceGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiConferenceGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiConferenceGet$Xml(params?: ApiConferenceGet$Xml$Params, context?: HttpContext): Observable<ConferenceModelListResult> {
    return this.apiConferenceGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ConferenceModelListResult>): ConferenceModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiConferenceGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiConferenceGet$Plain$Response(params?: ApiConferenceGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ConferenceModelListResult>> {
    return apiConferenceGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiConferenceGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiConferenceGet$Plain(params?: ApiConferenceGet$Plain$Params, context?: HttpContext): Observable<ConferenceModelListResult> {
    return this.apiConferenceGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ConferenceModelListResult>): ConferenceModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiConferenceGet$Any()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiConferenceGet$Any$Response(params?: ApiConferenceGet$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<ConferenceModelListResult>> {
    return apiConferenceGet$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiConferenceGet$Any$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiConferenceGet$Any(params?: ApiConferenceGet$Any$Params, context?: HttpContext): Observable<ConferenceModelListResult> {
    return this.apiConferenceGet$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<ConferenceModelListResult>): ConferenceModelListResult => r.body)
    );
  }

}
